export const tabelaCodigoSaida: Record<string, string[]> = {
  '02': ['4.3.10', '4.3.17'],
  '03': ['4.3.11'],
  '04': ['4.3.10', '4.3.11'],
  '05': ['4.3.12'],
  '06': ['4.3.13'],
  '07': ['4.3.14'],
  '08': ['4.3.15'],
  '09': ['4.3.16'],
};
